import * as React from 'react'

import { styled } from '../../../common/ui'
import { theme } from '../theme'

export class Label extends React.Component<
  { label: string; isRequied: boolean; htmlFor: string },
  {}
> {
  render() {
    const { htmlFor, label, isRequied } = this.props
    return (
      <Container htmlFor={htmlFor}>
        {label}
        {isRequied ? (
          <IsRequied>(wymagane)</IsRequied>
        ) : (
          <IsOptional>(opcjonalnie)</IsOptional>
        )}
      </Container>
    )
  }
}

const Container = styled.label`
  font-weight: normal;
  font-size: 17px;
  margin: 0 0 5px 0;
  padding: 0;
  display: block;
  color: #000;
`

const IsRequied = styled.span`
  color: ${theme.colors.blue};
  display: inline-block;
  font-weight: normal;
  margin-left: 5px;
`
const IsOptional = styled.span`
  color: ${theme.colors.gray};
  display: inline-block;
  font-weight: normal;
  margin-left: 5px;
`
